import { render, staticRenderFns } from "./CreateRiskScenario.vue?vue&type=template&id=67de2167&"
import script from "./CreateRiskScenario.vue?vue&type=script&lang=js&"
export * from "./CreateRiskScenario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports